/**
 * @flow
 * @relayHash b4568f1a558e8e6672ad8240eb402118
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AddPOApprovalRuleInput = {|
  minAmount?: ?number,
  maxAmount?: ?number,
  approverUserId: string,
|};
export type AddPOApprovalRuleMutationVariables = {|
  input: AddPOApprovalRuleInput
|};
export type AddPOApprovalRuleMutationResponse = {|
  +addPOApprovalRule: {|
    +poApprovalRuleEdge: {|
      +node: ?{|
        +id: string,
        +minAmount: ?number,
        +maxAmount: ?number,
        +approver: {|
          +id: string,
          +firstName: string,
          +lastName: string,
          +email: any,
        |},
        +createdAt: any,
      |}
    |}
  |}
|};
export type AddPOApprovalRuleMutation = {|
  variables: AddPOApprovalRuleMutationVariables,
  response: AddPOApprovalRuleMutationResponse,
|};
*/


/*
mutation AddPOApprovalRuleMutation(
  $input: AddPOApprovalRuleInput!
) {
  addPOApprovalRule(input: $input) {
    poApprovalRuleEdge {
      node {
        id
        minAmount
        maxAmount
        approver {
          id
          firstName
          lastName
          email
        }
        createdAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AddPOApprovalRuleInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "addPOApprovalRule",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AddPOApprovalRulePayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "poApprovalRuleEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "POApprovalRuleEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "POApprovalRule",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "minAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "maxAmount",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "approver",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "firstName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "lastName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AddPOApprovalRuleMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AddPOApprovalRuleMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AddPOApprovalRuleMutation",
    "id": null,
    "text": "mutation AddPOApprovalRuleMutation(\n  $input: AddPOApprovalRuleInput!\n) {\n  addPOApprovalRule(input: $input) {\n    poApprovalRuleEdge {\n      node {\n        id\n        minAmount\n        maxAmount\n        approver {\n          id\n          firstName\n          lastName\n          email\n        }\n        createdAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd533c99cf6f209220b6f1093e7d42217';
module.exports = node;
